export { Toggle, type ToggleProps } from "./Toggle.component";
